import { toUpper } from 'lodash';
import { PromotionCode } from '../../../types/items';

export const preparePromotionCode = (promotionCode: PromotionCode): PromotionCode => {
  const code = toUpper(promotionCode.code);
  return { ...promotionCode, code };
};
